module.exports = __webpack_public_path__ + "img/button-text-inline-code-on.55b92c4.svg";